import React from 'react';
import CountUp from 'react-countup';

const FunFact = (props) => {

    return (
        <section className={"" + props.hclass} >
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-doctor"></i>
                            <h3><CountUp end={25} enableScrollSpy />+</h3>
                            <p>Years of Experience</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-businesswoman"></i>
                            <h3><CountUp end={1000} enableScrollSpy />+</h3>
                            <p>Florida Patients Treated</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-award"></i>
                            <h3><CountUp end={4} enableScrollSpy />+</h3>
                            <p>Board Certifications</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-customer-care"></i>
                            <h3><CountUp end={2} enableScrollSpy /></h3>
                            <p>Hospital Affiliations</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default FunFact;